import { useParams, Link } from 'react-router-dom'
import { useApi } from '../hooks/useApi.js'
import { getProject } from '../lib/api.js'
import ErrorFallback from '../components/ErrorFallback.jsx'
import Skeleton from '../components/Skeleton.jsx'

function ProjectDetailPage() {
  const { slug } = useParams()
  const { data, loading, error, refetch } = useApi(() => getProject(slug), [slug])

  if (loading) {
    return (
      <div className="pg-layout">
        <div>
          <Skeleton className="h-14 w-64 mb-6" />
          <Skeleton className="h-4 w-full mb-3" />
          <Skeleton className="h-4 w-5/6 mb-8" />
          <Skeleton className="h-10 w-48" />
        </div>
        <div />
      </div>
    )
  }

  if (error) return <ErrorFallback message="Failed to load project" onRetry={refetch} />

  const project = data
  if (!project) return <ErrorFallback message="Project not found" />

  return (
    <div className="pg-layout">
      <div>
        <Link to="/projects" className="text-sm text-soft-dim hover:text-soft-ink mb-6 inline-block">
          ← All projects
        </Link>

        <div className="flex items-center gap-3 mb-4">
          <h1 className="text-[36px] sm:text-[48px] md:text-[56px] font-normal leading-[1.02] tracking-[-1.8px]">
            {project.title}
          </h1>
          {project.year && (
            <span className="font-mono text-[13px] text-soft-faint">
              {project.year}
            </span>
          )}
          {project.before_llms && (
            <span className="font-mono text-[10px] uppercase tracking-[0.5px] text-soft-faint bg-soft-hi px-2 py-0.5">
              pre‑llm era
            </span>
          )}
        </div>

        <div
          className="text-base leading-[1.7] text-soft-ink mb-8"
          dangerouslySetInnerHTML={{ __html: project.description }}
        />

        {project.tech_tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-8">
            {project.tech_tags.map((tech) => (
              <span key={tech} className="px-2 py-1 bg-soft-hi text-xs text-soft-ink">
                {tech}
              </span>
            ))}
          </div>
        )}

        <div className="flex gap-4">
          {project.url && (
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-soft-dim hover:text-soft-ink underline-offset-2 hover:underline"
            >
              Live demo →
            </a>
          )}
          {project.github_url && (
            <a
              href={project.github_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-soft-dim hover:text-soft-ink underline-offset-2 hover:underline"
            >
              GitHub →
            </a>
          )}
        </div>
      </div>

      <aside />
    </div>
  )
}

export default ProjectDetailPage
